import { statusOf, TONE_CLASS, type StatusDomain, type Tone } from '@/lib/status'
import { cn } from '@/lib/utils'

export interface StatusPillProps {
  domain: StatusDomain
  status: string
  /** For a draft: an approved one without a slot reads "슬롯 대기". */
  scheduledAt?: string | null
  className?: string
}

/** A state as the vocabulary names it: a dot and a label on the tone's fill. */
export function StatusPill({ domain, status, scheduledAt, className }: StatusPillProps) {
  const def = statusOf(domain, status, { scheduledAt })
  return <TonePill tone={def.tone} label={def.label} pulse={def.pulse} dim={def.dim} className={className} />
}

export function TonePill({
  tone,
  label,
  pulse,
  dim,
  className,
}: {
  tone: Tone
  label: string
  pulse?: boolean
  dim?: boolean
  className?: string
}) {
  const c = TONE_CLASS[tone]
  return (
    <span
      className={cn(
        'inline-flex h-5 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2 text-micro font-medium',
        c.soft,
        c.text,
        dim && 'opacity-60',
        className,
      )}
    >
      <StatusDot tone={tone} pulse={pulse} />
      {label}
    </span>
  )
}

/** The 6px dot alone, for dense rows. */
export function StatusDot({ tone, pulse, className }: { tone: Tone; pulse?: boolean; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn('h-1.5 w-1.5 shrink-0 rounded-full', TONE_CLASS[tone].dot, pulse && 'animate-status-blink', className)}
    />
  )
}
